import React from 'react';
import { PublicationListType } from 'generated/CoreApi_v1';
import { ListSystemViewer } from 'views/knowledge/publication/pages/List/ListSystemViewer';

export const FeedSeeLater: React.FC = () => {
  return <ListSystemViewer listType={PublicationListType.SeeLater} />;
}
